import http from './httpService'; 
const apiUrl = process.env.REACT_APP_API_URL;
const apiEndpoint = apiUrl + "/topics";


  function topicUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getTopics() {
    return http.get(apiEndpoint);
  }
  
  export function getTopic(Id) {
    return http.get(topicUrl(Id));
  }
  
  export function saveTopic(topic) {
    //clone
    const body = { ...topic };
    console.log(body);
   //update
   if (topic._id) {
     //delete _id
     delete body._id;
     return http.put(topicUrl(topic._id),body);
   }
   console.log(body);
   //add a new topic
   return http.post(apiEndpoint, body);
 }
  
  //delete topics
  export function deleteTopic(Id) {
    return http.delete(topicUrl(Id));
  }  